import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-location',
  templateUrl: './icon-location.component.html',
  styles: []
})
export class IconLocationComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
